import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default (reducers) => {
  const persistedReducer = persistReducer(
    {
      key: 'morelli',
      storage,
      whitelist: ['autenticacao', 'usuario', 'parceiro'],
    },
    reducers
  );

  return persistedReducer;
};
